$(document).ready(function(){

    $('body').on('click', '.scroll-to-form', function(e) {
        e.preventDefault();
        const target = $('#consultation-form');

        if (target.length) {
            $('html, body').stop().animate({
                scrollTop: target.offset().top - 80
            }, 800, 'swing');
        }
    });

    $('body').on('click', '.scroll-to-form', function(e) {
        e.preventDefault();
        var target = $($(this).attr('href'));
        if (target.length) {
            $('html, body').animate({
                scrollTop: target.offset().top - 100
            }, 600);
        }
    });

    var Realworkslider = new Swiper(".real-work-blocks", {
      slidesPerView: 1,
      spaceBetween: 10,
      centeredSlides: true,
      loop: true,
      scrollbar: {
            el: '.rw-swiper-scrollbar',
            hide: true,
        },
        navigation: {
            nextEl: ".real-work-slider-arrows .swiper-button-next",
            prevEl: ".real-work-slider-arrows .swiper-button-prev",
        },
        breakpoints: {
            749: {
                spaceBetween: 40
            }
        }
    });

    function initRecentDropsSlider() {
        return new Swiper(".our-recent-drops-blocks", {
            slidesPerView: 1,
            spaceBetween: 10,
            loop: false,
            scrollbar: {
                el: '.our-recent-drops-scrollbar',
                hide: false,
            },
            navigation: {
                nextEl: ".our-recent-drops-arrows .swiper-button-next",
                prevEl: ".our-recent-drops-arrows .swiper-button-prev",
            },
            breakpoints: {
                749: {
                    spaceBetween: 25,
                    slidesPerView: 3
                },
                989: {
                    spaceBetween: 40,
                    slidesPerView: 3
                }
            }
        });
    }
    // Initial load
    var Realworkslider = initRecentDropsSlider();

    $('body').on('click','.our-recent-drop-tab', function () {
        const tabText = $(this).data('tab');
        console.log('tabText',tabText)
        $(this).closest('.our-recent-drops-tabs').find('.our-recent-drop-tab').removeClass('active');
        $(this).addClass('active');
        const parent = $(this).closest('.our-recent-drops-section');
        parent.find('.our-recent-drops-item').each(function () {
            const tabItem = $(this).data('item');
            console.log('tabItem',tabItem);   
            if(tabItem.includes(tabText))  {
                $(this).addClass('active');
            } else {
                $(this).removeClass('active');
            }
        })
        // Restart Swiper after DOM update
        setTimeout(() => {
            if (Realworkslider) {
                Realworkslider.destroy(true, true);
            }
            Realworkslider = initRecentDropsSlider();
        }, 50);
    })

    var testiSlider = new Swiper(".testi-sec-blocks", {
      slidesPerView: 1,
      spaceBetween: 15,
      centeredSlides: true,
      loop: false,
        navigation: {
            nextEl: ".testi-sec-slider-arrows .swiper-button-next",
            prevEl: ".testi-sec-slider-arrows .swiper-button-prev",
        },
        breakpoints: {
            749: {
                spaceBetween: 40
            }
        }
    }); 

    if (window.innerWidth <= 749) {
        $("body").on("click", ".footer-block--menu .footer-block__heading, .footer-block--contact .footer-block__heading", function () {
            var activeTitle = $(this);
            activeTitle.toggleClass("active");
            var currentDropdown = activeTitle.next(".footer-block--menu .footer-block__details-content, .footer-block--contact .footer-block__contact");
            $(".footer-block--menu .footer-block__heading, .footer-block--contact .footer-block__heading").not(activeTitle).removeClass("active");
            $(".footer-block--menu .footer-block__details-content, .footer-block--contact .footer-block__contact").not(currentDropdown).slideUp();
            currentDropdown.stop(true, true).slideToggle();
        });
    }

})

// COUNT DONW JS
function isPartiallyInView($el) {
  var elementTop = $el.offset().top;
  var elementBottom = elementTop + $el.outerHeight();
  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();

  // Returns true if any part of the element is visible
  return elementBottom > viewportTop && elementTop < viewportBottom;
}
function isFullyOutOfView($el) {
  var elementTop = $el.offset().top;
  var elementBottom = elementTop + $el.outerHeight();
  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();

  // Returns true if element is entirely above or below the viewport
  return elementBottom <= viewportTop || elementTop >= viewportBottom;
}
function counterFun() {
    const counterElement = $('.countdown-blocks');
    if(counterElement.length) {
        if (isPartiallyInView(counterElement)) {
            $('.countdown-block').each(function () {
                let $count = $(this).find('.count');
                let countTo = parseInt($count.attr('data-count'), 10);
                if (!$(this).hasClass('counted')) {
                    $(this).addClass('counted');
                    $({ countNum: 0 }).animate(
                        { countNum: countTo },
                        {
                        duration: 2000,
                        easing: 'swing',
                        step: function () {
                            $count.text(Math.floor(this.countNum));
                        },
                        complete: function () {
                            $count.text(countTo)
                        }
                        }
                    )
                }
            })
        }else if (isFullyOutOfView(counterElement)) {
            // Reset only when fully out of view
            $('.countdown-block').each(function () {
                $(this).removeClass('counted').find('.count').text('0');
            });
        }
    }
}
$(window).on('scroll resize', counterFun);
$(document).ready(counterFun);

// COUNTDOWN JS END

(function ($) {
    var SELECTOR = '[data-portfolio]';
    var EVT = '.portfolio';

    function initPortfolio(scope) {
        var $roots = scope ? $(scope).find(SELECTOR).addBack(SELECTOR) : $(SELECTOR);

        $roots.each(function () {
        var $root = $(this);
        if ($root.data('portfolioInit')) return;
        $root.data('portfolioInit', true);

        $root.on('click' + EVT, '.portfolio-tab', function () {
            var filter = String($(this).data('filter'));

            $root.find('.portfolio-tab').removeClass('is-active');
            $(this).addClass('is-active');

            $root.find('.portfolio-card').each(function () {
            var $card = $(this);
            var show = filter === 'all' || String($card.data('category')) === filter;
            $card.toggleClass('is-hidden', !show);
            });
        });
        });
    }

    function destroyPortfolio(scope) {
        $(scope).find(SELECTOR).addBack(SELECTOR).off(EVT).removeData('portfolioInit');
    }

    $(document).ready(function () { initPortfolio(); });
    $(document).on('shopify:section:load', function (e) { initPortfolio(e.target); });
    $(document).on('shopify:section:unload', function (e) { destroyPortfolio(e.target); });
})(jQuery);